import React from 'react'

export default class EdadBiologica extends React.Component {
  render () {
    // console.log('estas son las propiedad', this.props.propiedades)
    return (
      <div className='someText' contentEditable='true'>
        <div className='someText-body'>
          { (this.props.propiedades.biologicalAgeResult === 'mala')
            ? ' Su edad biológica es mucho mayor que la edad cronológica. Revise si hay desequilibrios en sus cuatro áreas vitales: física, mental, social y emocional. Mire si el nivel de ejercicio físico puede ser mejor.'
            : (this.props.propiedades.biologicalAgeResult === 'apropiada')
            ? ' Mantiene la edad biológica en forma. Sin embargo, puede ganar años de vida biológica. ¡Podemos decirle cómo hacerlo!'
            : (this.props.propiedades.biologicalAgeResult === 'excelente')
            ? ' A su edad, su organismo está biológicamente más joven que los años que tiene. ¡Esto es maravilloso, hay que mantenerse así!' : ''
          }
        </div>
      </div>
    )
  }
}

EdadBiologica.propTypes = {
  propiedades: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDashboard/edadBiologicaText.js